import { render } from "./TextIcon.vue?vue&type=template&id=41457278"
import script from "./TextIcon.vue?vue&type=script&lang=js"
export * from "./TextIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__